<div class="bgc-fasb-blue-dialog font-white dialog-24 confirm-dialog-text">
  <div class="pl-1-25 ptb-1-25 float-L" tabindex="0">{{displayTitle}}&nbsp;<strong></strong></div>
  <div class="pr-1-25 ptb-1-25 float-R cursor-pointer" (click)="onNoClick()" (keyup.enter)="onNoClick()" tabindex="0"><strong>X</strong></div>
</div>
<div class="confirm-dialog">
    <div class="pt-1-25 confirm-dialog-text" tabindex="0" [innerHTML]="message">
    </div>
  <div class="flex-display confirm-dialog-button-margin">
    <div mat-dialog-actions class="dialog-button">
      <button *ngIf="!EnableOkButton" appAutoFocus mat-button class="confirm-dialog-no" (click)="onNoClick()" (keyup.enter)="onNoClick()" tabindex="0">No</button>
      <button *ngIf="!EnableOkButton" mat-button class="confirm-dialog-yes" [mat-dialog-close]="true" (click)="onYesClick()" cdkFocusInitial>Yes</button>
      <div class="pl-2-5">
        <button *ngIf="EnableOkButton" appAutoFocus mat-button class="confirm-dialog-yes" (click)="onGenerateReportAlertClick()" (keyup.enter)="onGenerateReportAlertClick()" tabindex="0">OK</button>
      </div>
    </div>
  </div>
</div>
